import { useForm } from "react-hook-form";
import FormField from "./FormField";
import { useTranslation } from "react-i18next";

type IForm = {
  [k: string]: string;
};

const RefundFormModal = ({
  onSubmit,
  onClose,
}: {
  onSubmit: (data: IForm) => void;
  onClose: () => void;
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<IForm>();
  const { t } = useTranslation();
  const formFields = [
    {
      label: t("Full name"),
      name: "fullName",
      type: "text",
      required: true,
      placeholder: t("Please enter your full name"),
    },
    {
      label: t("Book no2"),
      name: "bookNo",
      type: "text",
      required: true,
      placeholder: t("Please enter your book no"),
    },
    {
      label: t("Email2"),
      name: "email",
      type: "email",
      required: true,
      placeholder: t("Please enter your email2"),
    },
    {
      label: t("Content"),
      name: "content",
      type: "textarea",
      required: true,
      placeholder: t("Please enter your content"),
    },
  ];
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="relative w-[31.25rem] max-w-3xl rounded-[1rem] border border-[#D7DCE3] bg-white shadow-lg">
        <div className="px-4 py-6">
          <h1 className="mb-4 text-center text-2xl font-semibold">
            {t("Refund / Cancel Application")}
          </h1>
          <p className="mb-6 text-center text-sm text-gray-500">
            {t(
              "Exclusive Refund Policy of Tamice! Refunds will be processed immediately once the conditions are met! Please enter the name, order number, and email address you used during purchase.",
            )}
          </p>
          <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
            {formFields.map((field) => (
              <FormField
                key={field.name}
                field={field}
                register={register}
                errors={errors}
                placeholder={field.placeholder}
              />
            ))}
            <div className="flex items-start">
              <input
                type="checkbox"
                {...register("agreement", {
                  required: "You must agree to the terms",
                })}
                className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
              />
              <label
                className="ml-2 text-sm text-gray-700"
                dangerouslySetInnerHTML={{
                  __html: t(
                    "I agree to the cancellation and Refund policy.",
                  ).replace(
                    t("Refund policy"),
                    `<a target="_blank" href="${window.location.origin}/p/termPolicy/cancelAndRefundPolicy" class="text-blue-500 underline">${t("Refund policy")}</a>`,
                  ),
                }}
              ></label>
            </div>
            {errors.agreement && (
              <p className="mt-1 text-sm text-red-500">
                {errors.agreement.message}
              </p>
            )}
            <div className="mt-4 grid grid-cols-2 gap-4">
              <button
                onClick={onClose}
                type="button"
                className="rounded-[3.4375rem] border border-[#232323] py-[0.8125rem] text-base font-semibold leading-[1.25rem] text-[#232323] hover:bg-gray-100"
              >
                {t("Cancel")}
              </button>
              <button
                type="submit"
                className={`${
                  //   !mutation.isLoading
                  true ? "bg-primary text-[#232323]" : "bg-[#DCDCDC] text-white"
                } rounded-[3.4375rem] py-[0.8125rem] text-base font-semibold leading-[1.25rem] text-[#232323]`}
              >
                {t("Submit")}
              </button>
            </div>
            <p className="mt-4 text-center text-xs text-gray-500">
              {t("The refund process may take up to 4 weeks.")}
            </p>
          </form>
        </div>
      </div>
    </div>
  );
};

export default RefundFormModal;
